import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { useFragment } from "react-relay";

import { useInitEventForm_formQuestionConfiguration$key } from "./__generated__/useInitEventForm_formQuestionConfiguration.graphql";
import { EventDetailFormConfigurationAtom } from "./eventForm";

export const useInitEventForm = ({
  fragmentRef,
}: {
  fragmentRef: useInitEventForm_formQuestionConfiguration$key | null;
}) => {
  const data = useFragment(useInitEventFormFragmentString, fragmentRef);
  const setEventFormConfigurations = useSetAtom(
    EventDetailFormConfigurationAtom
  );

  useEffect(() => {
    if (data) {
      const formQuestionConfigurations =
        data?.formConfiguration?.formQuestionConfigurations?.edges
          ?.filter((f) => f?.node?.enabled)
          .map?.((f) => ({
            id: f?.node?.id ?? "",
            prompt: f?.node?.prompt ?? "",
            type: f?.node?.type ?? "TEXT",
            guestVisibility: f?.node?.guestVisibility ?? "NONE",
            memberVisibility: f?.node?.memberVisibility ?? "NONE",
            values: f?.node?.values?.map((v) => v) ?? [],
            enabled: f?.node?.enabled ?? false,
            shortname: f?.node?.shortName ?? "",
            target: f?.node?.target ?? "PLAYER",
          }));

      setEventFormConfigurations(formQuestionConfigurations ?? null);
    }
  }, [setEventFormConfigurations, data]);
};

export const useInitEventFormFragmentString = graphql`
  fragment useInitEventForm_formQuestionConfiguration on Event {
    formConfiguration {
      id
      formQuestionConfigurations {
        edges {
          node {
            id
            prompt
            type
            guestVisibility
            memberVisibility
            values
            enabled
            shortName
            target
          }
        }
      }
    }
  }
`;
